"use client";

import { Box, Flex, Text, type FlexProps } from "@chakra-ui/react";

export type SectionLabelProps = {
  /** Nhãn section (uppercase nhỏ) */
  children: React.ReactNode;
  /** Màu vạch ngang — token Chakra (vd: primary.500) */
  lineColor?: string;
  /** Màu chữ — mặc định trùng lineColor nếu không truyền */
  textColor?: string;
} & Omit<FlexProps, "children">;

/**
 * Label + gạch ngang nhỏ dùng chung cho các section landing redesign.
 */
export function SectionLabel({
  children,
  lineColor = "primary.600",
  textColor: textColorProp,
  mb = 3,
  gap = 2,
  align = "center",
  ...rest
}: SectionLabelProps) {
  const textColor = textColorProp ?? lineColor;

  return (
    <Flex align={align} gap={gap} mb={mb} {...rest}>
      <Box w="20px" h="0.5" bg={lineColor} borderRadius="1px" flexShrink={0} />
      <Text
        fontSize="11px"
        fontWeight="bold"
        letterSpacing="0.12em"
        textTransform="uppercase"
        color={textColor}
      >
        {children}
      </Text>
    </Flex>
  );
}
